import './applied_filter_view.js.coffee'

Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.AppliedBooleanView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  template: JST['backbone/templates/monitoring/filters/applied_boolean']

  initialize: ({searchQuery, title, trueField, falseField}) ->
    @searchQuery = notNull(searchQuery)
    @title = notNull(title)
    @trueField = notNull(trueField)
    @falseField = notNull(falseField)

  render: =>
    @$el.html(@template(
      searchQuery: @searchQuery
      title: @title
      trueFieldTitle: @trueField.getTitle()
      falseFieldTitle: @falseField.getTitle()
      trueFieldName: @trueField.getName()
      falseFieldName: @falseField.getName()
    ))
    @

  apply: =>
    @searchQuery.resetField(@trueField.getName())
    @searchQuery.resetField(@falseField.getName())
    @_triggerQueryChanged()

  _triggerQueryChanged: =>
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)
